module.exports = __webpack_public_path__ + "img/icon_parking.3eab7d74.png";